/* eslint-disable no-console */
// Mock localStorage when it is not allowed
let localStorage;
try {
  localStorage = window.localStorage;
} catch (error) {
  localStorage = {
    getItem: () => undefined,
    setItem: () => {}
  };
}

export const loadState = key => {
  try {
    const serializedState = localStorage.getItem(key);
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.warn(`Error loading local storage: ${error}`);
    return undefined;
  }
};

export const saveState = (state, key) => {
  try {
    const serializedState = state ? JSON.stringify(state) : '';
    localStorage.setItem(key, serializedState);
    if (key === 'userToken') {
      // Scope the same-window auth-state broadcast to our own origin.
      if (state) {
        window.postMessage({ type: 'jp-login-success' }, window.location.origin);
      } else {
        window.postMessage({ type: 'jp-logout-success' }, window.location.origin);
      }
    }
  } catch (error) {
    console.warn(`Error saving local storage: ${error}`);
  }
};

export const getToken = () => {
  const token = loadState('userToken') || null;
  return token;
};

export const getTokenGuest = () => {
  const token = loadState('guestToken') || null;
  return token;
};

export const getSessionId = () => {
  const sessionId = loadState('sessionId') || null;
  return sessionId;
};

export const getTokenApplyWidget = () => loadState('tokenApplyWidget') || null;
